import React, { type ReactNode, useEffect } from 'react';
import { Tab, TabList, Tabs } from 'react-tabs';
import { CustomTab, Heading, SeparatorContainer, SeparatorDot, StyledTabDiv } from './styles';

import type { TabContent } from 'server/repository/hygraph/generated/graphqlTypes';

export const GenericTabs = ({
  id = 'authorable-tabs',
  children,
  tabs,
  setSelectedTab,
  cmsTabTitle,
}: {
  id?: string;
  children: ReactNode;
  tabs: TabContent[];
  setSelectedTab: (index: number) => void;
  cmsTabTitle: string;
}) => {
  const allTabs = tabs?.map((item: any, index: number) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={item.id ?? `tabs-${index}`}>
      <Tab key={item.tabTitle} onClick={() => setSelectedTab(index)} role="button">
        <Heading itemProp="servingSize" tag="div" type={tabs && tabs.length > 3 ? 'xxs' : 'xs'}>
          {item.tabTitle}
        </Heading>
      </Tab>
      {}
      {tabs && index !== tabs.length - 1 && (
        <SeparatorContainer>
          <SeparatorDot />
        </SeparatorContainer>
      )}
    </React.Fragment>
  ));

  useEffect(() => {
    let tabListContainer: any = document.getElementById(`tabList-container${cmsTabTitle}`);
    tabListContainer = tabListContainer.getBoundingClientRect();
    let childrenContainer: any = document.getElementById(`children-container${cmsTabTitle}`);
    childrenContainer = childrenContainer.getBoundingClientRect();
    if (childrenContainer.top < tabListContainer.top + 80) {
      document.getElementById(`children-container${cmsTabTitle}`)?.classList.add('mt-16');
    }
  }, []);

  return (
    <>
      <CustomTab data-test={`${id}-authorable-tabs`}>
        <Tabs>
          <StyledTabDiv
            className="w-full overflow-y-auto sticky sm:top-14 md:top-20 bg-white z-22"
            id={`tabList-container${cmsTabTitle}`}
          >
            <TabList data-test={`${id}-all-tabs-list`}>{allTabs}</TabList>
          </StyledTabDiv>
          <div className="children-container" id={`children-container${cmsTabTitle}`}>
            {children}
          </div>
        </Tabs>
      </CustomTab>
    </>
  );
};
